import { createRouter, createWebHistory } from 'vue-router';
import { r7eBaseApp } from '../services/index.js';

const routes = [
    {
        path: '/info',
        name: 'AccountInfo',
        component: () => import('../views/AccountInfoView.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/account',
        name: 'Account',
        component: () => import('../views/AccountInfoView.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/settings', 
        name: 'Settings',
        component: () => import('../views/SettingsView.vue'),
        meta: { requiresAuth: false }
    },
    {
        path: '/notifications',
        name: 'Notifications',
        component: () => import('../views/NotificationsView.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/login',
        name: 'Login',
        beforeEnter: (to, from, next) => {
            // Check if magic link authentication is provided in query parameters
            const hasMagicLink = to.query.auth === 'magic-link' && 
                                 to.query.uid && 
                                 to.query.username && 
                                 to.query.token;
            
            // Allow access to login page if magic link is provided, even if already authenticated
            if (hasMagicLink) {
                next();
            } else if (r7eBaseApp.hasAccessToCurrentService()) {
                next('/');
            } else {
                next();
            }
        },
        component: () => import('../views/LoginView.vue'),
        meta: { requiresGuest: true }
    },
    {
        path: '/register',
        name: 'Register',
        beforeEnter: (to, from, next) => {
            const isAuthenticated = r7eBaseApp.isAuthenticated();
            const hasPendingRegistrationForCurrentService = isAuthenticated ? r7eBaseApp.hasPendingRegistrationForCurrentService() : false;

            if (hasPendingRegistrationForCurrentService) {
                next('/profile-setup');
            } else {
                const hasAccessToCurrentService = isAuthenticated ? r7eBaseApp.hasAccessToCurrentService() : false;
                if (hasAccessToCurrentService) {
                    next('/');
                } else {
                    next();
                }
            }
        },
        component: () => import('../views/RegisterView.vue'),
        meta: { requiresGuest: true }
    },
    {
        path: '/profile-setup',
        name: 'ProfileSetup',
        // beforeEnter: (to, from, next) => {
        //     if (r7eBaseApp.hasPendingRegistrationForCurrentService()) {
        //         next();
        //     } else {
        //         next('/');
        //     }
        // },
        component: () => import('../views/ProfileSetupView.vue'),
        props: (route) => ({
            redirectTo: route.query.redirectTo || ''
        }),
        meta: { requiresAuth: true }
    }, 
    // Redirect to login if no other route matches and not authenticated
    {
        path: '/:catchAll(.*)*',
        redirect: () => {
            return r7eBaseApp.hasAccessToCurrentService() ? '/' : '/login';
        },
    },    
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    // const requiresGuest = to.matched.some(record => record.meta.requiresGuest);
    const isAuthenticated = r7eBaseApp.isAuthenticated();
    const hasAccessToCurrentService = isAuthenticated ? r7eBaseApp.hasAccessToCurrentService() : false;

    // console.log('router.beforeEach', to.path, isAuthenticated, hasAccessToCurrentService);

    if (requiresAuth) {
        if (hasAccessToCurrentService) {
            const hasPendingRegistrationForCurrentService = hasAccessToCurrentService  ? r7eBaseApp.hasPendingRegistrationForCurrentService() : false;
            if (hasPendingRegistrationForCurrentService) {
                if (to.path !== '/profile-setup') {
                    next('/profile-setup');
                } else {
                    next();
                }
            } else {
                next();
            }
        } else {
            next('/login');
        }
    } else {
        const hasPendingRegistrationForCurrentService = hasAccessToCurrentService  ? r7eBaseApp.hasPendingRegistrationForCurrentService() : false;
        if (hasPendingRegistrationForCurrentService) {
            if (to.path !== '/profile-setup') {
                next('/profile-setup');
            } else {
                next();
            }
        } else if (to.path === '/' && isAuthenticated && !hasAccessToCurrentService) {
            next('/login');
        } else {
            next();
        }
    }
});

export {router};
export default router; 